import React from "react";

interface AlertItemProps {
  icon: string;
  title: string;
  description: string;
  onDismiss?: () => void;
  read?: boolean;
}

export const AlertItem: React.FC<AlertItemProps> = ({ icon, title, description, onDismiss, read = false }) => {
  return (
    <article className={`flex gap-1 items-start p-4 w-full bg-white rounded-xl border-2 border-solid ${read ? 'border-gray-200' : 'border-violet-500 border-opacity-90'}`}>
      <div className="flex flex-1 shrink gap-3 items-start basis-0 min-w-60">
        <img
          src={icon}
          alt=""
          className="object-contain shrink-0 w-7 rounded-full aspect-square"
        />
        <div className="flex flex-col flex-1 shrink basis-0 min-w-60">
          <h3 className="gap-1.5 self-start text-base font-medium text-slate-700">
            {title}
          </h3>
          <p className="text-sm leading-5 text-slate-600">
            {description}
          </p>
        </div>
      </div>
      <button 
        aria-label="Dismiss alert" 
        onClick={(e) => {
          e.preventDefault();
          onDismiss && onDismiss();
        }}
      >
        <img
          src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/1e4fa017396d43f8adfd0f0dec925cdfbca1a0bd?placeholderIfAbsent=true"
          alt="Close"
          className="object-contain shrink-0 w-5 aspect-square"
        />
      </button>
    </article>
  );
};
